module.exports = __webpack_public_path__ + "img/Group 124@2x.af73c7bd.png";